import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { SENTRY_PUBLIC_TOKEN } from '@utils/constants';

export const initSentry = (): void => {
    try {
        Sentry.init({
            dsn: SENTRY_PUBLIC_TOKEN,
            integrations: [new Integrations.BrowserTracing()],
            // We recommend adjusting this value in production, or using tracesSampler
            // for finer control
            // for now we keep this one
            tracesSampleRate: 1.0,
            release: process.env.REACT_APP_SENTRY_RELEASE,
            environment: process.env.REACT_APP_SENTRY_RELEASE?.split('-')[0],
        });
    } catch (error) {
        console.warn('Sentry.init error : ', error);
    }
};

export const setSentryUser = (user: { email: string; id: string }): void => {
    try {
        Sentry.setUser({
            id: user.id,
            email: user.email,
        });
    } catch (error) {
        console.warn('setSentryUser error ', error);
    }
};
